import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { catchError, from, Observable, switchMap, throwError } from "rxjs";
import { AuthService } from "./auth.service";

@Injectable({
    providedIn: 'root'
})
export class HttpInterceptorService implements HttpInterceptor {

    private authService = inject(AuthService);

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const user = this.authService.getCurrentUser();        
        if (!user) {
            return next.handle(req);
        }
        return from(user.getIdToken()).pipe(
            switchMap(token => {
                const authReq = req.clone({
                headers: req.headers
                    .set('Authorization', `Bearer ${token}`)
                    .set('Access-Control-Allow-Origin', '*')
                });
                return next.handle(authReq).pipe(
                    catchError(err => this._handleAuthError(err))
                );
            })
        );
    }    

    private _handleAuthError(err: any): Observable<never> {
        console.log('_handleAuthError', err);
        if (err instanceof HttpErrorResponse && err.status === 401) {        
             this.authService.logout();
        }
        return throwError(() => err);
    }
}